import EnumBasePicker from './EnumBasePicker'
import { VALUES } from '@/enums/WeekDays'

class WeeklyDatePicker extends EnumBasePicker {
  getEnumName () { return 'WeekDay' }
  getEnumValues () { return VALUES }
}

export default WeeklyDatePicker



// WEBPACK FOOTER //
// ./src/components/Editors/WeeklyDatePicker.js